;delta.reportList = function () {

    var

    _$wrapper = null,

    //set to true when a popup is open, can't open another
    _popup_open = false,

    //
    // init 
    //
    init = function () {
        _$wrapper = $('.layout-report-list');

        if (_$wrapper.length > 0) {
            disableEnterKey();
            setupDisconnect();
            setupConnectQBO();
            setupReportCompanyName();
            setupChangeDate();
            setupAddReport();
            setupDeleteReport();
            setupCopyReport();
        }
    },

    disableEnterKey = function () {
        document.addEventListener('keydown', function (event) {
            if (event.key === 'Enter') {
                event.preventDefault();
            }
        });
    },




    //
    // setup the disconnect quickbooks link
    //
    setupDisconnect = function () {
        _$wrapper.on('click', '#lnkDisconnect', function () {
            delta.qboAuth.disconnect('/reportlist');
            return false;
        });
    },

    //
    // Connect to Quickbooks button, save pageParams to sesstion storage first
    //
    setupConnectQBO = function() {
        _$wrapper.on('click', '#btnConnectQBO', function() {
            delta.qboAuth.connect('/reportlist', $(this).attr('data-url'));
            return false;
        });
    },



    setupReportCompanyName = function () {
        _$wrapper.on('click', '#lnkReportCompanyName', function () {
            if (!_popup_open) {
                _popup_open = true;

                delta.ajax.get(
                    '/reportlist/reportCompanyName',
                    function (html) {
                        delta.popup.open({
                            type: 'confirm',
                            title: 'Report Company Name',
                            content: html,
                            cssClass: 'report-company-name-popup',
                            afterOpen: function () {
                                _popup_open = false;
                            },
                            okCallback: function ($popup) {
                                $('.report-company-name-popup .modal-footer button').first().before('<i class="fa-regular fa-spinner fa-spin fs-3"></i>');

                                var formData = new FormData();
                                $popup.find('.modal-body').find('input').each(function () {
                                    var $elem = $(this);
                                    formData.append($elem.attr('name'), $elem.val());
                                });

                                delta.ajax.postFormData(
                                    '/reportlist/reportCompanyName',
                                    formData,
                                    function (result) {
                                        if (!result.ok) { //update popup
                                            $('.report-company-name-popup .modal-footer .fa-spinner').remove();
                                            $popup.find('.modal-body').html(result.popupHtml);
                                            delta.popup.enableButtons($popup);
                                        } else { location.reload(); }
                                    }
                                );

                                return false;
                            }
                        });

                    }
                );
            }

            return false;
        });

    },



    //
    // setup the change date popup
    //
    setupChangeDate = function () {
        _$wrapper.on('click', '#lnkChangeDate', function () {
            if (!_popup_open) {
                _popup_open = true;

                delta.ajax.get(
                    '/reportlist/changeDate',
                    function (html) {
                        delta.popup.open({
                            type: 'confirm',
                            title: 'Report Date',
                            content: html,
                            cssClass: 'change-date-popup',
                            afterOpen: function ($popup) {
                                _popup_open = false;

                                //setup date picker
                                delta.utility.setupDatePicker($popup);
                            },
                            okCallback: function ($popup) {
                                $('.change-date-popup .modal-footer button').first().before('<i class="fa-regular fa-spinner fa-spin fs-3"></i>');

                                var formData = new FormData();
                                $popup.find('.modal-body').find('input').each(function () {
                                    var $elem = $(this);
                                    formData.append($elem.attr('name'), $elem.val());
                                });

                                delta.ajax.postFormData(
                                    '/reportlist/changeDate',
                                    formData,
                                    function (result) {
                                        if (!result.ok) { //invalid update popup
                                            $('.change-date-popup .modal-footer .fa-spinner').remove();
                                            $popup.find('.modal-body').html(result.popupHtml);

                                            //setup date picker
                                            delta.utility.setupDatePicker($popup);
                                            delta.popup.enableButtons($popup);
                                        } else { location.reload(); }
                                    }
                                );

                                return false;
                            }
                        });
                    }
                );
            }

            return false;
        });
    },


    //
    // setup the add report button
    //
    setupAddReport = function () {
        $('#lnkAddReport').on('click', function () {
            $(".column-add-a").hide();
            _$wrapper.find('#lnkAddReport .icon-plus').hide();
            _$wrapper.find('#lnkAddReport .icon-spinner').show();

            if (!_popup_open) {
                _popup_open = true;

                delta.ajax.get(
                    '/reportlist/reportwizard',
                    function (html) {
                        delta.popup.open({
                            type: 'generic',
                            title: 'Add Report',
                            content: html,
                            cssClass: 'modal-newreport-wizard modal-lg',
                            afterOpen: function ($popup) {
                                _popup_open = false;
                            },
                            buttons: [
                                {
                                    text: 'Previous',
                                    isPrimary: false,
                                    leftAlign: true
                                },
                                {
                                    text: 'Next',
                                    isPrimary: true,
                                    leftAlign: true
                                },
                                {
                                    text: 'Cancel',
                                    isPrimary: false,
                                    callback: function ($popup) {
                                        delta.popup.close($popup);
                                    }
                                },
                                {
                                    text: 'Finish',
                                    isPrimary: false,
                                    callback: function ($popup) {
                                        delta.reportWizard.save($popup);
                                        return false;
                                    }
                                },

                            ],
                            cancelCallback: function () {
                                //fade in main popup
                                $('#autoPopup_1').css('opacity', '1');
                            }
                        });

                    }
                );
            }
        });
    },

    //
    // delete a report
    //
    setupDeleteReport = function () {
        _$wrapper.on('click', '.lnk-delete', function () {
            delta.popup.open({
                type: 'confirm',
                title: 'Delete Report',
                content: `Are you sure you want to delete <b>${this.dataset.reportTitle}</b>?`,
                okButtonText: 'Delete Report',
                cssClass: 'delete-report-popup',
                sourceId: this.dataset.reportId,
                okCallback: function ($popup, $cfg) {
                    var formData = new FormData();
                    formData.append('reportID', $popup.data('sourceId'));

                    delta.ajax.postFormData('/reportlist/delete', formData, function() { location.reload(); });
                    return false;
                }
            });
        });
    },

    setupCopyReport = function () {
        $(document).on('shown.bs.modal', '.modal-report-copy', function () {
            const $createCopyBtn = $(".modal-report-copy button[data-btn-index='1']");
            $($createCopyBtn).prop("disabled", true);

            $('#ReportTitle').trigger('focus');
            $("#ReportTitle").on("input paste cut change keyup", function () {
                if ($('#ReportTitle').val().trim() === "") {
                    $($createCopyBtn).prop("disabled", true);
                } else {
                    $($createCopyBtn).prop("disabled", false);
                }
            });
        });

        _$wrapper.on('click', '.lnk-copy', function () {

            if (!_popup_open) {
                _popup_open = true;
                var $a = $(this);
                var reportID = $a.attr('data-report-id');
                delta.ajax.get(
                    '/reportlist/ReportCopy?reportID=' + reportID,
                    function (html) {
                        delta.popup.open({
                            type: 'confirm',
                            title: 'Copy Report',
                            content: html,
                            cssClass: 'modal-report-copy',
                            okButtonText: 'Create Copy',
                            afterOpen: function ($popup) {
                                _popup_open = false;
                            },
                            okCallback: function ($popup) {
                                $('.required-label').remove();
                                if ($('#ReportTitle').val().trim() === "") {
                                    $('#ReportTitle').after('<label class="required-label text-danger mt-1">Report title is required</label>');
                                    $('#ReportTitle').trigger('focus');
                                    delta.popup.enableButtons($popup);
                                } else {

                                    $('#autoPopup_1 .modal-footer button').first().before('<i class="fa-regular fa-spinner fa-spin fs-3"></i>');
                                    var formData = new FormData();
                                    $popup.find('.modal-body').find('input[type="text"], input[type="hidden"]').each(function () {
                                        var $elem = $(this);
                                        var name = $elem.attr('name');
                                        formData.append(name, $elem.val());
                                    });

                                    delta.ajax.postFormData(
                                        '/reportlist/ReportCreateCopy',
                                        formData,
                                        function (result) {
                                            if (result.ok) {
                                                //close the popup
                                                $('.modal-newreport-wizard .modal-footer .fa-spinner').remove();
                                                delta.popup.close($popup);
                                                window.location = result.url; //redirect
                                            } else {
                                                $('.modal-newreport-wizard  .modal-footer .fa-spinner').remove();
                                                $popup.find('.modal-body').html(result.html);
                                                delta.popup.enableButtons($popup);
                                            }
                                        }
                                    );
                                }
                                delta.popup.enableButtons($popup);
                                return false;
                            }
                        });
                    }
                );
            }
            return false;
        });
    },


    dummy = function () { };

    $(document).ready(init);
}();